import LabelCeListController from './label.ce.list.controller';

export default {
    template: require('./label.ce.list.html'),
    controller: LabelCeListController
};
